import dayjs, { Dayjs } from "dayjs";
import { Box, styled } from "@mui/material";

import {
  CourseTitleSection,
  SchedulePeriodDisplay,
  TablePagination,
} from "@/components";

import { ScheduleResponseDto } from "@shared/generated/api/model";

interface MobileScheduleDashboardProps {
  schedules: ScheduleResponseDto[];
  selectedDate: Dayjs;
}

export const MobileScheduleDashboard = ({
  schedules,
  selectedDate,
}: MobileScheduleDashboardProps) => {
  const filteredSchedules = schedules.filter((schedule) =>
    dayjs(schedule.startsAt).isSame(selectedDate, "day"),
  );

  return (
    <Container>
      {filteredSchedules.map((schedule) => (
        <ScheduleCard
          key={`${schedule.id}-${schedule.cycle.id}-${schedule.sessionNumber}`}
        >
          <CourseTitleSection
            type={schedule.cycle.course.type}
            difficulty={schedule.cycle.course.difficulty}
            title={schedule.cycle.course.title}
            scheduleId={schedule.id}
            size="small"
          />
          <SchedulePeriodDisplay
            cycleStartsAt={schedule.cycle.startsAt}
            cycleEndsAt={schedule.cycle.endsAt}
            totalSessions={schedule.cycle.course.totalSessions}
            scheduleStartsAt={schedule.startsAt}
            scheduleEndsAt={schedule.endsAt}
            durationPerSession={schedule.cycle.course.durationPerSession}
            sessionNumber={schedule.sessionNumber}
            size="small"
          />
        </ScheduleCard>
      ))}
      <TablePagination
        page={1}
        totalPages={1}
        onPageChange={() => {}}
      />
    </Container>
  );
};

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 0,
  borderRadius: 8,
  border: "1px solid #D2D2D2",
  overflow: "hidden",
});

const ScheduleCard = styled(Box)({
  padding: "16px",
  backgroundColor: "#fff",
  borderBottom: "1px solid #D2D2D2",
  "&:last-child": {
    borderBottom: "none",
  },
});
